import { useDragLayer } from 'react-dnd';
import { NavbarContainerOverlayToolbar } from './items/Navbar/NavbarContainerOverlayToolbar';
import { NavbarMenuItemOverlayToolbar } from './items/Navbar/NavbarMenuItemOverlayToolbar';
import { ImageNotionAlertPopupOverlayToolbar } from './items/ImageNotionAlertPopupOverlayToolbar';
import PageSettings from './items/PageSettings';
import { NavbarDropdownContainerOverlayToolbar } from './items/Navbar/NavbarDropdownContainerOverlayToolbar';
import NavbarAddOption from './items/Navbar/NavbarAddOption';
import { useTPlateEditorRef } from '../../plate';
import { ELEMENT_NAVBAR } from '../../pluginKeys';

interface OverlayToolbarProps {
  disablePageSettings: boolean
  // eslint-disable-next-line react/require-default-props
  isNavbarExist?: boolean
}

export function OverlayToolbar(props: OverlayToolbarProps) {
  const { disablePageSettings, isNavbarExist } = props;
  const editor = useTPlateEditorRef();
  const isNavbarEnabled = !!editor.pluginsByKey[ELEMENT_NAVBAR];

  const { isDragging } = useDragLayer((monitor) => ({
    isDragging: monitor.isDragging(),
  }));

  return (
    <>
      <NavbarMenuItemOverlayToolbar />
      <NavbarContainerOverlayToolbar />
      <NavbarDropdownContainerOverlayToolbar />
      <ImageNotionAlertPopupOverlayToolbar />
      {/* There will be more here, like the "Add Navbar" button */}
      {!isNavbarExist && isNavbarEnabled && <NavbarAddOption />}
      {!isDragging && !disablePageSettings && <PageSettings />}
    </>
  );
}
